import { NitroFetchOptions, NitroFetchRequest } from 'nitropack';
import { useArticlesProjectConfig } from '../composables/useArticlesProjectConfig';

interface ApiResponseDto<T> {
  data?: T;
  limit?: number;
  pages?: number;
  count?: number;
  message?: string;
  timeStamp?: string;
  statusCode: number;
}

const baseArticleFetch = (id: string) => {
  const config = useRuntimeConfig();

  return $fetch.create({
    baseURL: config.public.articlesBaseUrl as string,
    params: { id },
    headers: { 'x-app': id },
  });
};

export async function articleFetch<T>(
  request: NitroFetchRequest,
  options?: NitroFetchOptions<NitroFetchRequest>,
) {
  const articlesProjectConfig = await useArticlesProjectConfig();

  try {
    const response = await baseArticleFetch(articlesProjectConfig.id)<ApiResponseDto<T>>(
      request,
      options,
    );

    if (!response) {
      return null as unknown as T;
    }

    if (response.data === undefined) {
      return null as unknown as T;
    }

    return response.data as T;
  } catch (error) {
    console.error('Error fetching from article service:', error);
    throw error;
  }
}
